import * as React from "react";

export const ReploIconBlack = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M0 32H16V16C13.8989 15.9992 11.8183 16.4126 9.87733 17.2165C7.93638 18.0204 6.17324 19.1991 4.68894 20.6849C1.68849 23.6878 0.00228481 27.7569 0 32Z"
      fill="black"
    />
    <path
      d="M0 15.9999V0H16C15.9941 4.24564 14.3082 8.31609 11.3111 11.3207C9.82837 12.8103 8.06522 13.9908 6.1237 14.794C4.18218 15.5972 2.10082 16.007 0 15.9999Z"
      fill="black"
    />
    <path
      d="M16 16H32V0C27.7589 -1.5584e-06 23.6913 1.68526 20.6911 4.68545C17.691 7.68565 16.0036 11.7553 16 16Z"
      fill="black"
    />
  </svg>
);
